import React, {Component} from 'react';
import "./Footer.scss"
import {NavLink} from "react-router-dom";
import {navsList} from "../../config/configPublic"
import {message} from 'antd';

export default class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            phone: "",
            content: "",
        }
    }

    getSubmit() {
        let {name, phone, content} = this.state;
        if (name === "") {
            message.error("请输入姓名",);
            return false;
        }
        if (!(/^1[3456789]\d{9}$/.test(phone))) {
            message.error("请输入手机号码");
            return false;
        }
        if (content === "") {
            message.error("请输入内容");
            return false;
        }
        let data = {
            "name": name,
            "phone": phone,
            "content": content,
        };
        this.$axios.apiList.getFooterSubmit(data)
            .then(res => {
                message.success("提交成功");
            })
            .catch(error => {
                message.error("提交失败");
            })
    }

    setInputValue(e) {
        let {name, value} = e.target;
        // this.state = value;
        this.setState({
            [name]: value
        });
    }

    render() {
        let {name, phone, content} = this.state;
        return (
            <div className="footer">
                <div className="footer-content">
                    <div className="footer-nav">
                        {
                            navsList.map(((item, index) => {
                                return (
                                    <NavLink key={index}
                                             to={item.pathUrl}
                                             className="item"
                                             activeStyle={{color: "#C31515"}}>
                                        {item.pathname}
                                    </NavLink>
                                )
                            }))
                        }
                    </div>
                    <div className="footer-wrapper">
                        <div className="left">
                            <div className="item">
                                <div className="icon">
                                    <i className="iconfont icon-shouye-dianhua"></i>
                                </div>
                                <div className="text">
                                    电话：0510-87029605
                                </div>
                            </div>
                            <div className="item">
                                <div className="icon">
                                    <i className="iconfont icon-shouye-youjian"></i>
                                </div>
                                <div className="text">
                                    邮箱：zhongya56@126.com
                                </div>
                            </div>
                            <div className="item">
                                <div className="icon">
                                    <i className="iconfont icon-shouye-yewufenbu"></i>
                                </div>
                                <div className="text">
                                    地址：宜兴经济技术开发区北环路东侧
                                </div>
                            </div>
                        </div>
                        <div className="right">
                            <div className="item">
                                <div className="icon">
                                    <i className="iconfont icon-shouye-liuyan"></i>
                                </div>
                                <div className="text">
                                    如有疑问请留言，我们会尽快回复
                                </div>
                            </div>
                            <div className="list">
                                <div className="item">
                                    <input type="text" value={name} name="name" onChange={e => {
                                        this.setInputValue(e)
                                    }} placeholder="姓名*"/>
                                </div>
                                <div className="item">
                                    <input type="text" value={phone} name="phone" onChange={e => {
                                        this.setInputValue(e)
                                    }} placeholder="电话*"/>
                                </div>
                                <div className="item">
                                    <input type="text" value={content} name="content" onChange={e => {
                                        this.setInputValue(e)
                                    }} placeholder="请简述内容*"/>
                                </div>
                                <div className="item">
                                    <div className="btn" onClick={this.getSubmit.bind(this)}>
                                        留言
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="record">
                    宜兴市交运物流信息科技有限公司 备案号： <a target="_blank" href="https://beian.miit.gov.cn/" style={{'color': '#1890ff', 'text-decoration':'underline'}} >苏ICP备18049070号-1</a>
                </div>
            </div>
        );
    }
}
